import axios from 'axios'
// import moment from 'moment'
import { startOfDay,
  format,
  endOfDay,
  startOfMonth,
  startOfISOWeek,
  endOfMonth,
  getISODay,
  addDays
} from 'date-fns' // add
import miniToastr from 'mini-toastr'
import configAll from '../../../../config/index.cjs'

const config = configAll[process.env.NODE_ENV === 'production' ? 'build' : (process.env.NODE_ENV === 'prodlocal') ? 'prodlocal' : 'dev']
const API_URL = config.urlServer
const GET_TODO_URL = `${API_URL}api/per/todo/`

export default {
  namespaced: true,
  state: {
    weeks: [],
    items: [],
    startWeek: '',
    endWeek: '',
    startWeekMonth: '',
    endWeekMonth: '',
    isSameMonth: false,
    currentWeekNr: 0,
    currentWeek: {}
  },
  mutations: {
    setWeeks (state, obj) {
      const output = []
      let clonedDate = obj.date;

      const firstDayOfMonth = startOfMonth(clonedDate)
      const firstDayOfWeek1 = startOfISOWeek(firstDayOfMonth)
      const lastOfMonth = endOfMonth(clonedDate)
      const firstDayOfWeekn = startOfISOWeek(lastOfMonth)
      let currentWeek = getClosestDayOfWeek('Mon', firstDayOfWeek1)
      const lastWeek = getClosestDayOfWeek('Mon', firstDayOfWeekn)
      /* eslint-disable no-unmodified-loop-condition */
      while (currentWeek <= lastWeek) {
        output.push({ start: new Date(currentWeek), end: addDays(new Date(currentWeek), 6) })
        currentWeek = addDays(new Date(currentWeek), 7)
      }
      // eslint-disable-next-line
      state.weeks = output;

      // eslint-disable-next-line
      state.items = [];
      // eslint-disable-next-line
      state.startWeek = '';
      // eslint-disable-next-line
      state.endWeek = '';
      // eslint-disable-next-line
      state.startWeekMonth = '';
      // eslint-disable-next-line
      state.endWeekMonth =  '';
      // eslint-disable-next-line
      state.isSameMonth = false;
      // eslint-disable-next-line
      state.currentWeekNr = 0;
      output.forEach((item, k) => {
        if ((item.start <= new Date()) && startOfDay(new Date()) <= item.end) {
          // eslint-disable-next-line
          state.currentWeekNr = k;
        }
      });
      // eslint-disable-next-line
      state.currentWeek = {};
    },
    setItems (state, obj) {
      // eslint-disable-next-line
      state.items = obj.data;
      // eslint-disable-next-line
      state.currentWeek = obj.currentWeek;
      // eslint-disable-next-line
      state.startWeek = format(new Date(state.currentWeek.start),'dd');
      // eslint-disable-next-line
      state.endWeek = format(new Date(state.currentWeek.end),'dd');
      // eslint-disable-next-line
      state.startWeekMonth = format(new Date(state.currentWeek.start),'MMM');
      // eslint-disable-next-line
      state.endWeekMonth = format(new Date(state.currentWeek.end),'MMM');
      // eslint-disable-next-line
      state.isSameMonth = state.startWeekMonth === state.endWeekMonth;
    },
    setItem (state, item) {
      state.items.push(item)
    },
    increment (state, val) {
      // eslint-disable-next-line
      state.currentWeekNr = state.currentWeekNr + val;
    },
    decrement (state, val) {
      // eslint-disable-next-line
      state.currentWeekNr = state.currentWeekNr - val;
    }
  },
  actions: {
    getWeeks ({ commit }, obj) {
      commit('setWeeks', obj)
    },
    getCurrentWeek ({ commit }, obj) {
      if (obj.op === 'add') {
        // eslint-disable-next-line
        obj.currentWeekNr += 1;
        commit('increment', 1)
      } else {
        commit('decrement', 1)
        // eslint-disable-next-line
        obj.currentWeekNr -= 1;
      }
      // eslint-disable-next-line
      obj.currentWeek = obj.weeks[obj.currentWeekNr - 1];
      const fromDate = format(startOfDay(new Date(obj.currentWeek.start)), 'yyyy-MM-dd HH:mm:ss')
      const endDate = format(endOfDay(new Date(obj.currentWeek.end)), 'yyyy-MM-dd HH:mm:ss')

      axios.get(`${GET_TODO_URL}?fromDate=${encodeURI(fromDate.toString())}&endDate=${encodeURI(endDate.toString())}`)
        .then((response) => {
          // eslint-disable-next-line
          commit('setItems', {data: response.data, currentWeek: obj.currentWeek});
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Get Current Week To Dos failed!', 1500);
        })
    },
    add ({ commit }, payload) {
      axios.post(GET_TODO_URL, payload)
        .then((response) => {
          commit('setItem', response.data)
          miniToastr.success('Added to do item', '', 1500)
        })
        .catch((err) => {
          // eslint-disable-next-line
          miniToastr.error(err.response.data.errorMessage, 'Add Week review row failed!', 1500);
        })
    },
    // eslint-disable-next-line
    edit ({ commit }, payload) {
      axios.put(GET_TODO_URL, payload, { params: { id: payload.id } })
        // eslint-disable-next-line
        .then((response) => {
          // commit('editItem', response.data)
          miniToastr.success('Edited to do item', '', 1500)
        })
        .catch((err) => {
          miniToastr.error(err.response.data.errorMessage, 'Edit Week review row failed!', 1500)
        })
    }
  }
}


function getClosestDayOfWeek(dayOfWeek, fromDate = new Date()) {
  // follow the getISODay format (7 for Sunday, 1 for Monday)
  const dayOfWeekMap = {
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thur: 4,
    Fri: 5,
    Sat: 6,
    Sun: 7,
  };

  // e.g. If today is Sunday, getISODay(fromDate) will returns 7
  // if the day we want to find is Thursday(4), apart from subtracting one week(-7),
  // we also need to account for the days between Sunday(7) and Thursday(4)
  // Hence we need to also subtract (getISODay(fromDate) - dayOfWeekMap[dayOfWeek])
  const offsetDays =  (getISODay(fromDate) - dayOfWeekMap[dayOfWeek]);

  return addDays(fromDate, offsetDays);
}